import { connect } from 'react-redux'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'

import { loadAttendantSettings } from '../../store/AppDeviceConfiguration/actions'
import { getAttendantSettingIsLoading } from '../../store/AppDeviceConfiguration/selector'
import { loadSuitesStaff } from '../../store/Staff/actions'
import { getSuitesStaffIsLoading } from '../../store/Staff/selector'
import { loadSalesEvents } from '../../store/Event/actions'
import { loadPreOrders } from '../../store/Order/actions'
import { loadRevenueCenters } from '../../store/RevenueCenter/actions'
import { getIsRevenueCentersLoading } from '../../store/RevenueCenter/selector'
import { loadCustomers } from '../../store/Customer/actions'
import { getIsCustomerLoading } from '../../store/Customer/selector'
import { loadAllCustomerOrderingPreferencesByEventId } from '../../store/CustomerOrderingPreference/actions'
import { getIsOrderingPreferencesLoading } from '../../store/CustomerOrderingPreference/selector'
import { fetchEmployeeRoles } from '../../store/EmployeeRole/actions'
import { makeGetSalesEvent, getFilters, getIsSalesEventLoading } from '../../store/Event/selector'
import { makeGetDisplaySuites, makeGetAllDisplaySuites, getSelectedSuites } from '../../store/Suite/selector'
import { getCurrentVenueUuid } from '../../store/Venues/selector'
import { getEmployeeRoles, getIsEmployeeRolesLoading } from '../../store/EmployeeRole/selector'
import { getPreOrders, getIsPreOrdersLoading } from '../../store/Order/selector'
import { setSelectedSuites, clearSelectedSuites } from '../../store/Suite/actions'
import { setCurrentPaginationPage } from '../../store/AppState/actions'
import { getCurrentPaginationPage, getScreenScrollOffset } from '../../store/AppState/selector'
import { setScreenScrollOffset } from '../../store/AppState/actions'

import paginationCoordinator from '../../utils/paginationCoordinator'

import SuitesEventDetails from '../../components/Event/Details'

const mapStateToProps = (state, ownProps) => {
  const navigation = get(ownProps, 'history', {})
  const eventId = get(ownProps, 'match.params.eventId')
  const getSalesEvent = makeGetSalesEvent()
  const getDisplaySuites = makeGetDisplaySuites()
  const getAllDisplaySuites = makeGetAllDisplaySuites()
  const employeeRoles = getEmployeeRoles(state)
  const allDisplaySuites = getAllDisplaySuites(state, eventId)
  const salesEvent = getSalesEvent(state, eventId)
  const displaySuites = getDisplaySuites(state, eventId)
  const showEmptySuites = getFilters(state).showEmptySuites
  const suites = showEmptySuites ? allDisplaySuites : displaySuites
  const paginator = paginationCoordinator(suites, navigation)
  const selectedSuites = getSelectedSuites(state)
  const currentVenueUuid = getCurrentVenueUuid(state)
  const preOrders = getPreOrders(state)
  const currentPersistedPaginationPage = getCurrentPaginationPage(state, 'eventDetails')
  const offsetToScroll = getScreenScrollOffset(state, 'eventDetails')

  const isSalesEventsLoading = getIsSalesEventLoading(state)
  const isSuitesStaffLoading = getSuitesStaffIsLoading(state)
  const isPreOrdersLoading = getIsPreOrdersLoading(state)
  const isRevenueCentersLoading = getIsRevenueCentersLoading(state)
  const isCustomerLoading = getIsCustomerLoading(state)
  const isOrderingPreferencesLoading = getIsOrderingPreferencesLoading(state)
  const isAttendantSettingIsLoading = getAttendantSettingIsLoading(state)
  const isEmployeeRolesLoading = getIsEmployeeRolesLoading(state)

  const isLoading =
  isSalesEventsLoading ||
  isSuitesStaffLoading ||
  isPreOrdersLoading ||
  isRevenueCentersLoading ||
  isCustomerLoading ||
  isOrderingPreferencesLoading ||
  isAttendantSettingIsLoading ||
  isEmployeeRolesLoading

  return {
    currentVenueUuid,
    currentPersistedPaginationPage,
    employeeRoles,
    event: salesEvent,
    eventId,
    paginator,
    selectedSuites,
    preOrders,
    offsetToScroll,
    isLoading
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const salesEventId = get(ownProps, 'match.params.eventId', '')

  return {
    setScreenScrollOffset: (page) => dispatch(setScreenScrollOffset(page)),
    setCurrentPaginationPage: (page) => dispatch(setCurrentPaginationPage(page)),
    loadAttendantSettings: (currentVenueUuid, params) => dispatch(loadAttendantSettings(currentVenueUuid, params)),
    loadSalesEvents: (currentVenueUuid) => dispatch(loadSalesEvents(currentVenueUuid)),
    loadSuitesStaff: (currentVenueUuid) => dispatch(loadSuitesStaff(currentVenueUuid)),
    loadPreOrders: (currentVenueUuid) => dispatch(loadPreOrders(currentVenueUuid, salesEventId)),
    loadRevenueCenters: (venueUuid) => dispatch(loadRevenueCenters(venueUuid)),
    loadCustomers: (currentVenueUuid) => dispatch(loadCustomers(currentVenueUuid)),
    loadAllCustomerOrderingPreferencesByEventId: () => dispatch(loadAllCustomerOrderingPreferencesByEventId(salesEventId)),
    onMount: (currentVenueUuid) => {
      dispatch(clearSelectedSuites())
      dispatch(fetchEmployeeRoles(currentVenueUuid, null, salesEventId))
    },
    setSelectedSuites: (params) => dispatch(setSelectedSuites(params))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuitesEventDetails))
